import { pemToDer } from 'node-forge/pki'
import { crypto } from './re-exports'

/**
 * Returns the SHA1 hash of the public key string as a hex digest
 * @param publicKeyPem Public key to generate the id from
 */
export const generateKeyId = (publicKeyPem: string) =>
	crypto.sha1.create().update(pemToDer(publicKeyPem).bytes()).digest().toHex()
